import React, {FunctionComponent, useState} from "react";
import {makeStyles} from "tss-react/mui";
import {
    Container,
    CssBaseline,
    Theme,
    Typography,
} from "@mui/material";
import {RootStateOrAny, useSelector} from "react-redux";
import logo from "@/Style/crentweb-logo-black.svg";
import {getLocale, selectAppCode} from "@/Redux/App/AppReducer";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface IUserTokenInvalid {
}

const useStyles = makeStyles()((theme: Theme) => ({
    paper: {
        marginTop: "50%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        width: 200,
        paddingBottom: 15,
    },

    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },

    submit: {
        margin: theme.spacing(0, 0, 2),
    },
    buttonProgress: {
        position: "absolute",
        top: "33%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
    wrapper: {
        marginTop: theme.spacing(1),
        position: "relative",
    },

    error: {
        color: theme.palette.error.main,
    },
}));

const UserTokenInvalid: FunctionComponent<IUserTokenInvalid> = (): JSX.Element => {
    const {classes} = useStyles();
    const {t} = useTranslation();
    const language = useSelector((state) => getLocale());

    return (
        <Container component="main" maxWidth="md">
            <CssBaseline/>
            <div className={classes.paper}>
                <img className={classes.avatar} src={logo} alt={"crw-logo"}/>
                <Typography component="h1" variant="h5">
                    {t("general.messages.userTokeninvalid")}
                </Typography>
                <Typography component="h1" variant="h5">
                    {t("general.messages.crw6ModuleNotActiveText2")}
                </Typography>
            </div>
        </Container>
    );
};

export default UserTokenInvalid;